<bz-return-btn-arrow [easyBack]="true" (pushBtnReturn)="pushBtnBack()" class="btn-back">
  <p>{{ 'back' | transloco }}</p>
</bz-return-btn-arrow>

<div class="advice-tip-wrapper">
  <nav class="crumbs scrollbar">
    <span>
      <a [routerLink]="getHomePageLink()">{{ 'search-for-drugs' | transloco }}</a>
    </span>
    <span>
      <a>{{ (adviceDayTip | async)?.title }}</a>
    </span>
  </nav>

  <p class="advice-tip-title">{{ (adviceDayTip | async)?.title }}</p>

  <picture class="advice-tip-image" *ngIf="(adviceDayTip | async)">
    <source [srcset]="images + (adviceDayTip | async)?.photo + '.webp'" type="image/webp">
    <img bz-image [src]="images + 'png/' + (adviceDayTip | async)?.photo + '.png'" [title]="'tipOfTheDay' | transloco"
      alt="advice-day-tip">
  </picture>

  <p class="advice-tip-description">{{ (adviceDayTip | async)?.description }}</p>
  <div class="tips-wrapper">
    <p class="advice-tip-list-name">{{ (adviceDayTip | async)?.listName }}</p>
    <div class="advice-tip-step" *ngFor="let step of (adviceDayTip | async)?.listItems" [innerHTML]="step | safeHTML"></div>
  </div>
</div>
